import Controller from "./formStep.controller";
import template from "./formStep.html";

const slidingStep = {
  template,
  controller: Controller,
  bindings: {
    stepTitle: "@",
    stepForm: "=?",
  },
  transclude: true,
  require: {
    $stepsCtrl: "^formStepper",
  },
};

export default slidingStep;



// WEBPACK FOOTER //
// ./src/components/formStep/formStep.component.js